namespace TabAurous.HR {
    export interface SalaryComponentRow {
        SalaryComponentId?: number;
        Code?: string;
        Type?: Common.SalaryComponentType;
        Narration?: string;
    }

    export namespace SalaryComponentRow {
        export const idProperty = 'SalaryComponentId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'HR.SalaryComponent';
        export const lookupKey = 'HR.SalaryComponent';

        export function getLookup(): Q.Lookup<SalaryComponentRow> {
            return Q.getLookup<SalaryComponentRow>('HR.SalaryComponent');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            SalaryComponentId = "SalaryComponentId",
            Code = "Code",
            Type = "Type",
            Narration = "Narration"
        }
    }
}
